import { createContext, use, useLayoutEffect } from 'react';

/**
 * Lets a page fill the screen (the flow editor): the sidebar stays collapsed
 * and the page doesn't scroll. AppLayout provides it; without it, it's a no-op.
 */
export const FullBleedContext = createContext<(on: boolean) => void>(() => {});

/** Call from a page that should fill the screen while it's mounted. */
export function useFullBleed() {
  const setFullBleed = use(FullBleedContext);
  useLayoutEffect(() => {
    setFullBleed(true);
    return () => setFullBleed(false);
  }, [setFullBleed]);
}
